// Firebase config — MISMO proyecto que la app admin (nara-e491e). El aislamiento
// está en el backend: un usuario del admin NO puede entrar aquí a menos que
// exista también en la tabla `usuarios_socios`.
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCAbuMNk7g4nV_HBQTrn_8GsBqHbFpkFqg',
  authDomain: 'nara-e491e.firebaseapp.com',
  projectId: 'nara-e491e',
  storageBucket: 'nara-e491e.firebasestorage.app',
  messagingSenderId: '725126190772',
  appId: '1:725126190772:web:76b41423ae01c6a723a9e1',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
